export default "__VITE_ASSET__Bdgo_X5B__"